<!-- =========================================================================================
    File Name: Dashboard.vue
    Description: Dashboard page
========================================================================================== -->


<template>
    <div>
        <!-- ROW 1-->
        <div class="vx-row">
            <div class="vx-col w-1/2 md:w-1/3 xl:w-1/4">
                <dashboard-card
                  hideChart
                  class="mb-base"
                  icon="CheckCircleIcon"
                  :statistic="countOfActiveChannel"
                  :total="countOfTotalChannel"
                  :statisticTitle="this.$t('DASHBOARD_CHANNEL')"
                  color='success' />
            </div>

            <div class="vx-col w-1/2 md:w-1/3 xl:w-1/4">
                <dashboard-card
                  hideChart
                  class="mb-base"
                  icon="XCircleIcon"
                  :statistic="countOfErrorChannel"
                  :statisticTitle="this.$t('DASHBOARD_CHANNEL_ERROR')"
                  color='danger' />
            </div>

            <div class="vx-col w-1/2 md:w-1/3 xl:w-1/4">
                <dashboard-card
                  hideChart
                  class="mb-base"
                  icon="VideoIcon"
                  :statistic="countOfActivatedDashcam"
                  :total="countOfTotalDashcam"
                  :statisticTitle="this.$t('DASHBOARD_DASHCAM')"
                  color='primary' />
            </div>

            <div class="vx-col w-1/2 md:w-1/3 xl:w-1/4">
                <dashboard-card
                  hideChart
                  class="mb-base"
                  icon="UserCheckIcon"
                  :statistic="countOfSubscriptionYUser"
                  :total="countOfTotalUser"
                  :statisticTitle="this.$t('DASHBOARD_USER')"
                  color='warning' />
            </div>
        </div>

        <div class="vx-row">
             <!-- LINE CHART -->
            <div class="vx-col w-full mb-base">
                <vx-card :title="this.$t('WOWZA_USAGE')">
                    <div slot="no-body" class="p-6 pb-0">
                        <div class="flex">
                            <div class="mr-6">
                                <p class="mb-1 font-semibold">{{thisMonth}}</p>
                                <p class="text-3xl text-success">{{sumOfThisMonth}}<sup class="text-base mr-1">Kbps</sup></p>
                            </div>
                            <div>
                                <p class="mb-1 font-semibold">{{previousMonth}}</p>
                                <p class="text-3xl">{{sumOfPreviousMonth}}<sup class="text-base mr-1">Kbps</sup></p>
                            </div>
                        </div>
                        <div>
                        <vue-apex-charts
                          type=line
                          height=400
                          :options="lineChart.chartOptions"
                          :series="series" />
                        <p class="p-3 float-right text-base">{{this.$t("TIME_ZONE_MESSAGE")}}</p>
                        <br/><br/>
                        </div>
                    </div>
                </vx-card>
            </div>
        </div>
    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import DashboardCard from '@/components/statistics-cards/DashboardCard.vue'

import moduleDashboard from "@/store/dashboard/moduleDashboard.js"

export default{
    components: {
        StatisticsCardLine,
        DashboardCard,
        VueApexCharts
    },
    data() {
        return {
            colorx:'primary',
            hasError: false,
            
            lineChart: {
                chartOptions: {
                    chart: {
                        toolbar: { show: true },
                        dropShadow: {
                        enabled: true,
                        top: 5,
                        left: 0,
                        blur: 4,
                        opacity: 0.10,
                        },
                    },
                    stroke: {
                        curve: 'smooth',
                        dashArray: [0, 10],
                        width: [4, 2],
                    },
                    grid: {
                        borderColor: '#e7e7e7',
                    },
                    legend: {
                        show: false,
                    },
                    colors: ['#F97794', '#b8c2cc'],
                    fill: {
                        type: 'gradient',
                        gradient: {
                            shade: 'dark',
                            inverseColors: false,
                            gradientToColors: ['#7367F0', '#b8c2cc'],
                            shadeIntensity: 1,
                            type: 'horizontal',
                            opacityFrom: 1,
                            opacityTo: 1,
                            stops: [0, 100, 100, 100]
                        },
                    },
                    markers: {
                        size: 0,
                        hover: {
                            size: 5
                        }
                    },
                    xaxis: {
                        labels: {
                            style: {
                                cssClass: 'text-grey fill-current',
                            }
                        },
                        axisTicks: {
                            show: false,
                        },
                        axisBorder: {
                            show: false,
                        },
                    },
                    yaxis: {
                        tickAmount: 5,
                        labels: {
                            style: {
                                cssClass: 'text-grey fill-current',
                            },
                            formatter: function(val) {
                                return val.toLocaleString()+" Kbps";
                            }
                        },
                    },
                    tooltip: {
                        x: { show: true }
                    }
                }
            },

            downProcess: [],            
    }},
    created() {
        if (!moduleDashboard.isRegistered) {
            this.$store.registerModule('dataDashboard', moduleDashboard)
            moduleDashboard.isRegistered = true
        }
        this.$vs.loading()
        this.$store.dispatch("dataDashboard/fetchWowzaDailyReport")
        this.$store.dispatch("dataDashboard/fetchDownloadCount").then(() =>{
                this.$vs.loading.close()
        })
    },
    computed: {
        series(){
            return this.$store.state.dataDashboard.wowzaDailyReportSeries
        },
        countOfTotalChannel() {
            return this.$store.state.dataDashboard.countOfTotalChannel.toLocaleString()
        },
        countOfActiveChannel(){
            return this.$store.state.dataDashboard.countOfActiveChannel.toLocaleString()
        },
        countOfErrorChannel(){
            return this.$store.state.dataDashboard.countOfErrorChannel.toLocaleString()
        },
        countOfTotalDashcam(){
            return this.$store.state.dataDashboard.countOfTotalDashcam.toLocaleString()
        },
        countOfActivatedDashcam(){
            return this.$store.state.dataDashboard.countOfActivatedDashcam.toLocaleString()
        },
        countOfTotalUser(){
            return this.$store.state.dataDashboard.countOfTotalUser.toLocaleString()
        },
        countOfSubscriptionYUser(){
            return this.$store.state.dataDashboard.countOfSubscriptionYUser.toLocaleString()
        },
        sumOfThisMonth(){
            return this.$store.state.dataDashboard.sumOfThisMonthWowzaTotalUsage.toLocaleString()
        },
        sumOfPreviousMonth(){
            return this.$store.state.dataDashboard.sumOfPreviousMonthWowzaTotalUsage.toLocaleString()
        },
        thisMonth(){
            let locale = this.$i18n.locale
            if(locale === 'ko'){
                return moment().format('YYYY년 MM월')
            }else{
                return moment().format('YYYY. MM')
            }
        },
        previousMonth(){
            let locale = this.$i18n.locale
            if(locale === 'ko'){
                return moment().subtract(1, 'months').format('YYYY년 MM월')
            }else{
                return moment().subtract(1, 'months').format('YYYY. MM')
            }
        }
    },
    methods: {
        getSeries(partitions){
            let series = []
            for(let partition in partitions){
                series.push(partitions[partition].use)
            }
            return series
        },
        setChartOptions(agent){
            if(agent.machineType === "AP"){
                return this.chartOptions_web
            }else if(agent.machineType === "DB"){
                return this.chartOptions_db
            }
        },
        setMemoryPercentage(memory){
            const total = memory.total;
            const free = memory.free;
            const used = memory.used;

            return Math.round(((total-free-used)/total)*100);
        },
        getProcessColor(process){
            const running = process.running

            let processUp = 'bg-success'
            let processDown = 'bg-danger'

            if(running){
                return processUp
            }else{
                return processDown
            }
        },
        getServerStatus(agent){
            let processes = agent.resource.processes
            for(let index in processes){
                if(!processes[index].running){
                    return false
                }
            }
            return true
        },
        getAgentStatusColor(status) {
            if(status === "") return "primary"
            if(status === "up") return "success"
            if(status === "down") return "danger"
        },
        getPercentClass(percent){
            if(percent >= 90){
                return "text-danger font-bold"
            }
        },
    }
}
</script>
